import * as AccountStore from '../../store/AccountStore';
import * as React from 'react';

import AccountAttach from '../account/accountAttach/AccountAttach';
import AddBoldIcon from '../../images/dynamicIcons/addBoldIcon';
import { ApplicationState } from '../../store';
import CloseIcon from '../../images/dynamicIcons/closeIcon';
import PersonalAccountIcon from '../../images/dynamicIcons/personalAccountIcon';
import { PersonalAccountInformation } from '../../models/AccountModels';
import { Popup } from './Modals';
import { RouteComponentProps } from 'react-router';
import ScrollPosition from '../../constants/enums/ScrollPositionEnum';
import { Spinner } from '../components/Loader';
import addIcon from '../../images/addIcon.svg';
import bucketIcon from '../../images/bucketIcon.svg';
import { connect } from 'react-redux';
import edgeLeftDisabledIcon from '../../images/edgeLeftDisabledIcon.svg';
import edgeLeftIcon from '../../images/edgeLeftIcon.svg';
import edgeRightDisabledIcon from '../../images/edgeRightDisabledIcon.svg';
import edgeRightIcon from '../../images/edgeRightIcon.svg';
import listArrowIcon from '../../images/listArrowIcon.svg';

type AccountStateProps =
    AccountStore.AccountStateState &
    typeof AccountStore.actionCreators &
    RouteComponentProps<{}>;

interface ActionListState {
    scrollPosition: ScrollPosition,
    sliderShow: boolean,
    isListOpen: boolean,
    listWidth: number,
    attachIsOpen: boolean,
    unatachedAccount: string,
    unattachProcessed: boolean,
    reqistrationHintButtonWidth: number,
    windowWidth: number,
    unattachSuccess: boolean,
    unattachError: boolean,
}

class AccountSelector extends React.PureComponent<AccountStateProps, ActionListState> {

    constructor(props: AccountStateProps) {
        super(props);

        this.state = {
            scrollPosition: ScrollPosition.Left,
            sliderShow: false,
            isListOpen: false,
            listWidth: 0,
            attachIsOpen: false,
            unatachedAccount: "",
            unattachProcessed: false,
            reqistrationHintButtonWidth: 0,
            windowWidth: 0,
            unattachSuccess: false,
            unattachError: false
        }


        this.LeftScroll_onClick = this.LeftScroll_onClick.bind(this);
        this.RightScroll_onClick = this.RightScroll_onClick.bind(this);
        this.arraymove = this.arraymove.bind(this);
        this.Element_onResize = this.Element_onResize.bind(this)

        this.props.InitAccountLenghtResizeAction(this.Element_onResize);
    }

    private Hint_Render() {
        var addBtn = document.getElementById("attachAccountBtn_1");
        var leftPos = 0;

        if (window.innerWidth > 1024 && addBtn !== undefined)
            leftPos = (addBtn?.offsetLeft as number + this.state.reqistrationHintButtonWidth + 29)
        else
            leftPos = (addBtn?.offsetLeft as number | 0 + this.state.reqistrationHintButtonWidth + 39) / 2
        if (isNaN(leftPos)) leftPos = 0;

        return <div className='registration-hint'>
            <div className="accounts_button registration-hint_button button"
                style={{ top: addBtn?.offsetTop, left: addBtn?.offsetLeft, width: this.state.reqistrationHintButtonWidth, height: addBtn?.clientHeight }}
                onClick={() => { this.props.RegistrationHintCloseAction(); this.props.SetAttachOpen(true) }}>
                <div className='accounts_button_icon'><AddBoldIcon /></div>
                <div className='button-text' >Добавить лицевой счет</div>
            </div>

            <div className="registration-hint_cloud" style={{
                top: isNaN(addBtn?.offsetTop as number) ? 0 : addBtn?.offsetTop as number - 45,
                left: leftPos
            }}>
                <div className='title-bold'>Завершите регистрацию</div>
                <div className='close-btn button'
                    onClick={() => this.props.RegistrationHintCloseAction()}>
                    <CloseIcon />
                </div>
                <div className='name-passive--10 small'>Добавьте лицевой счет, чтобы просматривать  историю начислений, отслеживать статус заявок, оплачивать и подключать услуги.</div>
                <div>
                    <div className='text-med'>Где найти номер лицевого счета?</div>
                    <ul>
                        <li>В квитанции за обслуживание домофона. Номер лицевого счета располагается рядом с данными о плательщике</li>
                        <li>В приложении «Умный Дом.ru». Перейдите в раздел меню «Кабинет» и нажмитена кнопку «Оплата услуг», номер располагается рядом с адресом</li>
                    </ul>
                </div>
                <div className='name-passive--8 small'>Если у вас возникли сложности с добавлением лицевого счета, свяжитесь с <a href='https://cyfral-group.ru/all_towns' className='link-text small'>контакт-центром</a></div>

            </div>

        </div>

    }

    async Element_onResize() {
        var scroller = document.getElementById("accounts_items");
        var mainItem = document.getElementById("accounts_main_item");
        var addBtn = document.getElementById("attachAccountBtn_1");
        this.setState({
            listWidth: mainItem?.offsetHeight as number + 30,
            sliderShow: (scroller?.scrollWidth as number) > (scroller?.clientWidth as number + 110),
            reqistrationHintButtonWidth: addBtn?.clientWidth as number,
            windowWidth: window.innerWidth
        })
    }

    async componentDidMount() {
         
      
        this.Element_onResize();
        document.body.onresize = this.Element_onResize
    }
    async componentWillUnmount() {
        document.body.onresize = null
    }


    private LeftScroll_onClick() {
        var scroller = document.getElementById("accounts_items");
        var scrollLeft = scroller?.scrollLeft as number;
        scroller?.scroll({ top: 0, left: (scrollLeft - 378), behavior: 'smooth' });
        this.setState({
            scrollPosition:
                scrollLeft - 378 <= 0 ?
                    ScrollPosition.Left :
                    ScrollPosition.Middle
        })
    }

    private RightScroll_onClick() {

        var scroller = document.getElementById("accounts_items");
        var scrollLeft = scroller?.scrollLeft as number;
        scroller?.scroll({ top: 0, left: scrollLeft + 378, behavior: 'smooth' });
        this.setState({
            scrollPosition:
                scrollLeft + 378 >= (scroller?.scrollWidth as number - (scroller?.clientWidth as number)) ?
                    ScrollPosition.Right :
                    ScrollPosition.Middle
        })
    }

    arraymove<T>(arr: T[], fromIndex: number, toIndex: number) {

        if (arr.length > fromIndex) {
            var newArr = arr.slice();
            var element = newArr[fromIndex];
            newArr.splice(fromIndex, 1);
            newArr.splice(toIndex, 0, element);
            return newArr;
        }
        return arr
    }

    async UnattachAccoutn_onClick() {
        if (!this.state.unattachProcessed) {
            await this.setState({ unattachProcessed: true })
            let accountCount = this.props.accounts.length;
            await this.props.UnAttachAccountAction(this.state.unatachedAccount)
            if (accountCount !== this.props.accounts.length)
                await this.setState({ unattachProcessed: false, unattachSuccess: true })

            else
                await this.setState({ unattachProcessed: false, unattachError: true })
        }
    }

    public render() {

        return (
            <>
                {this.props.registrationHintShow && this.props.isExistsMainContact && this.Hint_Render()}

                <Popup isOpen={this.state.unatachedAccount !== ""} onClose={() => this.setState({ unatachedAccount: "" })}>
                    <div className='info-popup'>
                        <div className=' info-popup_close button' onClick={() => this.setState({ unatachedAccount: "" })}>
                            <CloseIcon />
                        </div>
                        <div className='info-popup_wrapper'>
                            <div className='text-bold'>Удаление лицевого счета</div>
                            <div className='name-passive--8'>Подтвердите удаление лицевого счета. Вы всегда можете добавить лицевой счет повторно.</div>
                        </div>
                        <div className='info-popup_button button button-text' style={{ background: "#FF2C5E" }}
                            onClick={() => this.UnattachAccoutn_onClick()}>{this.state.unattachProcessed ? <Spinner /> : "Подтвердить"}</div>
                    </div>
                </Popup>
                <Popup isOpen={this.state.unattachSuccess} onClose={() => this.setState({ unattachSuccess: false, unatachedAccount: "" })}>
                    <div className='info-popup'>
                        <div className='info-popup_wrapper'>
                            <div className='text-bold'>Успех!</div>
                            <div className='name-passive--8'>Лицевой счет удален</div>
                        </div>
                        <div className='info-popup_button  button button-text'
                            onClick={() => this.setState({ unattachSuccess: false, unatachedAccount: "" })}>Закрыть</div>
                    </div>
                </Popup>
                <Popup isOpen={this.state.unattachError} onClose={() => this.setState({ unattachError: false, unatachedAccount: "" })}>
                    <div className='info-popup'>
                        <div className='info-popup_wrapper'>
                            <div className='text-bold'>Что-то пошло не так!</div>
                            <div className='name-passive--8'>Не удалось удалить лицевой счет, попробуйте позднее</div>
                        </div>
                        <div className='info-popup_button red button button-text'
                            onClick={() => this.setState({ unattachError: false, unatachedAccount: "" })}>Закрыть</div>
                    </div>
                </Popup>
                <AccountAttach />
                {this.props.accounts.length > 0
                    ?
                    <>
                        <div className='accounts'>
                            <div className='accounts_add-button' onClick={() => this.props.SetAttachOpen(true)}>
                                <img src={addIcon}></img>
                            </div>
                            <div className='accounts_items' id="accounts_items">
                                {this.props.accounts.map((element, index) => {
                                    return <div className={`accounts_items_item ${this.props.selectedAccount === index && "selected"}`} key={index}
                                        onClick={() => this.props.SelectAccountAction(index)}>

                                        <div className='accounts_items_item_info'>
                                            <div className='text-norm'>{element.balance.address}</div>
                                            <div className='text-med'>ЛС {element.balance.personalAccount}</div>
                                        </div>
                                        <div className='accounts_items_item_info_icon'
                                            onClick={(e) => { e.stopPropagation(); this.setState({ unatachedAccount: element.balance.personalAccountId }) } }>
                                            <img src={bucketIcon}></img>
                                        </div>
                                    </div>
                                })}
                            </div>
                            <div className='accounts_slider' style={{ display: !this.state.sliderShow ? "none" : 'flex' }}>
                                <div className='accounts_slider_button' onClick={() => this.LeftScroll_onClick()}>
                                    {this.state.scrollPosition === ScrollPosition.Left ?
                                        <img src={edgeLeftDisabledIcon}></img> :
                                        <img src={edgeLeftIcon}></img>}
                                </div>
                                <div className='accounts_slider_button' onClick={() => this.RightScroll_onClick()}>
                                    {this.state.scrollPosition === ScrollPosition.Right ?
                                        <img src={edgeRightDisabledIcon}></img> :
                                        <img src={edgeRightIcon}></img>}
                                </div>
                            </div>
                        </div>
                        <div className='accounts--mobile'>
                            <div className={`accounts_items ${this.state.isListOpen && "isOpen"}`}
                                onClick={() => this.setState({ isListOpen: !this.state.isListOpen })}
                                style={{ maxHeight: this.state.isListOpen ? "500px" : (document.getElementById("accounts_main_item") === null ? 500 : document.getElementById("accounts_main_item")?.offsetHeight as number) + 30 }}>
                                <img className='accounts_items_item_info_arrow' src={listArrowIcon}></img>
                                <div className='accounts_items_item_info_title'><div className='text-bold'>Выберите аккаунт</div></div>
                                <div className='accounts_items_item_wrapper' >

                                    {this.arraymove<PersonalAccountInformation>(this.props.accounts, this.props.selectedAccount, 0).map((element, index) => {
                                        return <div className='accounts_items_item' id={index === 0 ? `accounts_main_item` : ""} key={index}
                                            onClick={(e) => {
                                                if (this.state.isListOpen) {
                                                    e.stopPropagation();
                                                    this.props.SelectAccountAction(index === 0 ? this.props.selectedAccount : index === this.props.selectedAccount ? 0 : index)
                                                    this.setState({ isListOpen: false })
                                                }
                                                else this.setState({ isListOpen: true })
                                            }}>
                                            <div className='accounts_items_item_icon'><PersonalAccountIcon /></div>
                                            <div className='accounts_items_item_info'>
                                                <div className='text-norm'>{element.balance.address}</div>
                                                <div className='text-med'>ЛС {element.balance.personalAccount}</div>
                                                <div className='accounts_items_item_info_icon'
                                                    onClick={(e) => { e.stopPropagation(); this.setState({ unatachedAccount: element.balance.personalAccountId }) } }>
                                                    <img src={bucketIcon}></img>
                                                </div>
                                            </div>

                                            <div className='accounts_items_item_info_space'></div>
                                        </div>
                                    })}

                                    <div className='accounts_button button' onClick={() => this.props.SetAttachOpen(true)}>
                                        <div className='accounts_button_icon'><AddBoldIcon /></div>
                                        <div className='button-text' >Добавить лицевой счет</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    : <div className='account_no-item_wrapper'>
                        <div className='account_no-item'>
                            <div className='account_no-item_header'>
                                <div className='accounts_items_item_icon'><PersonalAccountIcon /></div>
                                <div className='value-text'>Нет информации о лицевых счетах</div>
                            </div>
                            <div onClick={() => this.props.SetAttachOpen(true)} id={"attachAccountBtn_1"} className='accounts_button button' >
                                <div className='accounts_button_icon'><AddBoldIcon /></div>
                                <div className='button-text'>Добавить лицевой счет</div>
                            </div>
                        </div>
                    </div>}
            </>
        );

    }
};

export default connect(
    (state: ApplicationState) => state.AccountState,
    AccountStore.actionCreators
)(AccountSelector as any);
